import React, { useEffect, useRef, useState, useCallback } from "react";
import './styles/App.css';
import './styles/Mobile.css';
import TopBar from './TopBar';
import BottomBar from './BottomBar';
import SideMenu from './SideMenu';
import OptionTop from './OptionsTop';
import i18n from './i18n';
import LocaleContext from './LocaleContext';
import { useTranslation } from "react-i18next";
import { SideOpt } from "./OptionsSide";
import LoadingScreen from "./LoadingScreen";
import { bgValues, colorMaterials, currCanopy, currentBG, currentPalette, currStem, currVariation, getGoodCanopy, getGoodName, isAnyUpper, mapERP, prevBG, prevCanopy, prevPalette, prevStem, prevVariation, productID, sortOrder, sortOrderProduct, transformExt } from "./MyFunctions";
import PrintPage from "./PrintPage";
//import { Chat } from "./Chat";
import RightOpt from "./RightOpt";
import Env3D from "./Env3D";
import PDF from "./PDF";
import Cart from "./Cart";
import OnBoarding from "./OnBoarding";
import Possibilities from "./Possibilities";
import SystemSecurityUpdateWarningRoundedIcon from '@mui/icons-material/SystemSecurityUpdateWarningRounded';
import axios from "axios";
import pako from 'pako';
//import {data} from  "./MyFunctions";

var setPurl = 0;
var setProductUrl = 0;
// var variationNum = 0;
// var variationNum2 = 0;
var dc = null;
var modelMtls = {};
let tmpModel;
let comp3D = []
var loadValue = 0;
const appVersion = "7.8.9";
/*var eventNumber = 0;
window.test = 'NICE';*/


function App() {
    // const erpLink = "https://la-erp.witify.io/api";
    // const erpLink = "https://erp.luminaireauthentik.com/api";

    // //const urlShort = "https://192-46-223-43.ip.linodeusercontent.com";
    // //const urlShort = "https://172-105-97-91.ip.linodeusercontent.com";

    const urlShort = "https://3d.luminaireauthentik.com"; // Latest
    const urlApi = urlShort + ":3000/api/";
    const url = urlApi + "data";

    // const urlShort = "http://10.0.1.95";
    // const urlApi = urlShort + ":4000/api/";
    // const url = urlApi + "data";

    //const pathName = window.location.pathname;
    //console.log(pathName);
    const urlParams = new URLSearchParams(window.location.search);

    const [locale, setLocale] = useState(i18n.language);
    const [currency, setCurrency] = useState("CAD");
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    // const [dataERP, setDataERP] = useState([]);
    const [iframe, setIframe] = useState(null)
    //const iframe = document.getElementById('appIframe');
    const [productIframe, setProductIframe] = useState(null)
    const [thumbError, setThumbError] = useState(false)
    //const productIframe = document.getElementById('productIframe');
    const [loadScreen, setLoadScreen] = useState(true);
    const [loadScreenInit, setLoadScreenInit] = useState(true);
    const [loadMtlScreen, setLoadMtlScreen] = useState(true);
    const [cart, setCart] = useState({ build: 'none', lampshade: 'none' });
    const [currentBGid, setCurrentBGid] = useState(null);

    // erp data
    const [erpParameters, setErpParameters] = useState([]);
    const [currParameters, setCurrParameters] = useState([]);
    const [erpRecipes, setErpRecipes] = useState([]);
    const [erpProducts, setErpProducts] = useState([]);
    //const [dc, setDC] = useState(null);

    const [forceUpdate, setForceUpdate] = useState(false);

    const [required, setRequired] = useState({ build: false, lampshade: false, options: false });
    const [preSubmit, setPreSubmit] = useState(false);

    const [thumb, setThumb] = useState();



    // URL parameter
    /*const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);*/
    const [code, setCode] = useState(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
    let urlCode = urlParams.get('code');
    let urlMode = urlParams.get('mode') ? urlParams.get('mode') : '';

    //const [title,setTitle] = useState("main"); // "main" = normal title | "bg" = Background color | "palette" = Color palette | "mtl" = material library

    const [err, handleErr] = useState(false);

    useEffect(() => {
        document.title = t("mainTitle");
        document.documentElement.setAttribute("lang", i18n.language);

        // Fetch all data from database
        if (!Object.keys(data).length) {
            fetch(url)
                .then(res => res.json())
                .then((json) => {
                    setData(json);
                    getERPdatav2(json);

                    // getERPdata(json, "geographies")
                    // getERPdata(json, "colors")
                    // getERPdata(json, "parameters")
                    // getERPdata(json, "products")

                    // getERPdata(json, "geographies")
                    //console.log(dbWithPhotos(json));
                    urlMode.includes('product') && window.parent.postMessage({ apiDB: dbWithPhotos(json) }, "*"); // trigger event to parent for product page
                    urlParams.get('lang') && i18n.changeLanguage(urlParams.get('lang'));
                    urlParams.get('currency') && setCurrency(urlParams.get('currency'));
                    // console.log(dbWithPhotos(json));
                })
                .catch(err => handleErr(true))
        }
    }, [setData, t, data]);

    // const forceUpdateJson = async () => {
    //     try {
    //         const response = await fetch(urlApi + 'erp/update');
    //         const result = await response.json();
    //         console.log(result.message);
    //     } catch (error) {
    //         console.error('Error:', error);
    //     }
    // };
    const forceUpdateJson = async () => {
        try {
            const response = await axios.get(urlApi + 'erp/update', {
                headers: {
                    'x-secret-key': 'f$f423y25FfdsQ149fdFdz%',
                },
            });

            console.log(response.data);
        } catch (error) {
            console.error('Error during force update:', error);
        }
    };

    function setTheLoading(toLoad) {
        /*if (toLoad) {
            loadValue++
        } else {
            loadValue--
        }
        if (loadValue === 0) {
            setLoadScreen(false);
        } else {
            setLoadScreen(true);
    }*/
        setLoadScreen(toLoad);
        //    console.log(toLoad, loadValue);
    }


    // function getERPdatav2(db) {
    //     axios.get(
    //         urlApi + "erp/datav2", {
    //     }).then(res => {
    //         console.log(res)
    //     })
    // }
    const getERPdatav2 = async (db) => {
        try {
            // const response = await axios.get(urlShort + ":4000/data.json.gz", {  //LOCAL
            const response = await axios.get(urlShort + ":3000/data.json.gz", {     //PROD
                responseType: 'arraybuffer', // Important pour traiter les fichiers binaires
            });

            // Décompression
            const decompressedData = pako.ungzip(new Uint8Array(response.data), { to: 'string' });
            const j = JSON.parse(decompressedData);

            // filter pre made products
            const tmpProducts = j.products.filter((el) => !el.is_pre_made);
            const invalidProductID = j.products.filter((el) => el.is_pre_made).map(el => el.id);
            const tmpRecipes = j.recipes.map((el) => ({
                ...el,
                products: el.products.filter((el2) => !invalidProductID.includes(el2.id))
            }));
            j.products = tmpProducts;

            setErpParameters(j.parameters)
            // console.log(j)
            setErpProducts(tmpProducts)

            //RECIPES
            setErpRecipes(tmpRecipes);
            var tmp = [];
            const arr = ["builds", "lampshades"];
            for (let a of arr) {
                for (let l of db[a]) {
                    // var tp = false;
                    for (let l2 of tmpRecipes) {
                        if (l.code === l2.code_3d) {
                            tmp.push(l2)
                            l.dataERP = l2;
                        }
                    }
                }
            }
            //COLORS
            // const arrColor = ["colors", "finitions"];
            const arrColor = ["colors"];
            for (let c of db.colors) {
                for (let a of arrColor) {
                    for (let c2 of j[a]) {
                        if (c.code === c2.code_3d) {
                            c.dataERP = c2;
                        }
                    }
                }
            }

            // CANOPIES
            for (let c of db.canopy) {
                const cano = j.parameters.find(el => el.name === "Canopy Type");
                for (let c2 of cano.values) {
                    const erpCanoCode = getGoodCanopy(c2.name);
                    if (c.code === erpCanoCode) {
                        c.dataERP = c2;
                    }
                }
            }
            // console.log(db)
            initMaterialsERP(j.parameters, db);


            /*---------------------------------------------------------------------------------------------------------------*/
            /*------------------------------------------ Regarder s'il y a des doublons -------------------------------------*/
            /*---------------------------------------------------------------------------------------------------------------*/
            // var tmp2 = [];
            // for (let eD of j.recipes) {
            //     // if ((eD.type === "build" || eD.type === "lampshade") &&
            //     //     eD.code_3d === null &&
            //     //     !eD.name.toLowerCase().includes("discontinued") &&
            //     //     !eD.name.toLowerCase().includes("archive") &&
            //     //     !eD.name.toLowerCase().includes("do not") &&
            //     //     !eD.name.toLowerCase().includes("ne pas") &&
            //     //     !eD.name.toLowerCase().includes("cct") &&
            //     //     !eD.name.toLowerCase().includes("kit") &&
            //     //     !eD.name.toLowerCase().includes("test") &&
            //     //     !eD.name.toLowerCase().includes("n/a") &&
            //     //     !eD.name.toLowerCase().includes("zeynep") &&
            //     //     !eD.name.toLowerCase().includes("ssense") &&
            //     //     !eD.name.toLowerCase().includes("ord") &&
            //     //     !eD.name.toLowerCase().includes("copie") &&
            //     //     !eD.name.toLowerCase().includes("custom")
            //     // ) {
            //     //     tmp2.push(eD)
            //     // }
            //     if ((eD.type === "build" || eD.type === "lampshade") && eD.code_3d) {
            //         tmp2.push({ id: eD.id, name: eD.name, type: eD.type, code: eD.code_3d })
            //     }
            // }
            // // console.log(tmp2)
            // const groupedByCode3d = tmp2.reduce((acc, obj) => {
            //     if (!acc[obj.code]) {
            //         acc[obj.code] = [];
            //     }
            //     acc[obj.code].push(obj);
            //     return acc;
            // }, {});
            // const duplicates = Object.values(groupedByCode3d).filter(group => group.length > 1);
            // console.log(duplicates)
            /*---------------------------------------------------------------------------------------------------------------*/
            /*---------------------------------------------------------------------------------------------------------------*/
            /*---------------------------------------------------------------------------------------------------------------*/

            // console.log(j);
            // console.log(db);
        } catch (error) {
            console.error('Error fetching or decompressing JSON:', error);
        }
    };

    // const zeType = "recipes";
    // get data from ERP
    function getERPdata(db, type) {
        console.log(type);
        axios.get(
            urlApi + "erp?param=" + type, {
            // headers: { Authorization: "Bearer "+process.env.REACT_APP_API_TOKEN }
        }).then(res => {
            console.log(res)
            if (!res.data.error) {

                // Transform data from ERP to Edge data
                const erp = res.data.data;
                if (type === "recipes") {
                    // setTheLoading(true);
                    // this.finish = "done";
                    const arr = ["builds", "lampshades"];
                    setErpRecipes(erp);
                    // Inject ERP data into Edge database
                    var tmp = [];
                    // var tmp3 = [];
                    for (let a of arr) {
                        for (let l of db[a]) {
                            // var tp = false;
                            for (let l2 of erp) {
                                if (l.code === l2.code_3d) {
                                    tmp.push(l2)
                                    l.dataERP = l2;
                                    // tp = true;
                                }
                            }
                            // if (!tp) {
                            //     tmp3.push(l.code)
                            // }
                        }
                    }
                    // console.log(tmp)


                } else if (type === "colors" || type === "finitions") {
                    for (let c of db.colors) {
                        for (let c2 of erp) {
                            if (c.code === c2.code_3d) {
                                c.dataERP = c2;
                            }
                        }
                    }
                    // console.log(erp);
                    if (type === "colors") {
                        getERPdata(db, "finitions")
                    } /*else {
                    getERPdata(db, "parameters")
                }*/
                } else if (type === "parameters") {
                    console.log(erp);
                    // setErpParameters(erp)

                    // setLoadScreenInit(false);
                    // initMaterialsERP(erp, db);
                    // getERPdata(db, "products")
                    // console.log(erp);

                } else if (type === "products") {
                    // console.log(erp);
                    // if (urlMode.includes('product')) {
                    //     setProductUrl++;
                    // }
                    setErpProducts(erp)
                    // if (urlCode !== null) {
                    //     if (setPurl === 0) {
                    //         setPurl++;
                    //     }
                    // }
                    // setTheLoading(false);
                    // console.log(erp);
                } else {
                    console.log(erp)
                }
            }
        })
    }

    function checkProductsNotDone(recipes, products) {
        let res = [];
        let tmp = [];
        for (let p of products) {
            for (let r of p.recipes) {
                const code = getERPrecipeByID(r.id, recipes);
                if (!code.code_3d) {
                    if (tmp.indexOf(code) === -1) {
                        tmp.push(code)
                        res.push({ name: code.name, type: code.type });
                    }
                }
            }
        }
        return res;
    }


    function getERPrecipeByID(id, recipes) {
        let rs;
        for (let r of recipes) {
            if (r.id === id) {
                rs = r;
            }
        }
        return rs;
    }

    function transformProductERP(id, products, recipes) {
        let rtn = { build: null, lampshade: null };
        const pro = products.find(p => p.id === parseInt(id));
        if (!pro) return;

        for (let r of pro.recipes) {
            const rec = getERPrecipeByID(r.id, recipes);
            rtn[rec.type] = rec;
        }

        return rtn;
    }

    useEffect(() => {
        if (erpProducts.length > 0 && erpRecipes.length > 0 && erpParameters.length > 0) {
            // console.log("ERP done!")
            // console.log(data)
            // console.log(checkProductsNotDone(erpRecipes, erpProducts))
            setLoadScreenInit(false);

            if (urlMode.includes('product')) {
                setProductUrl++;
            }
            if (urlCode !== null) {
                if (setPurl < 2 && !iframe) {
                    setPurl++;
                }
            }
        }
    }, [erpProducts, erpRecipes, erpParameters]);

    // Obtenir les produits manquants dans le configurateur 3D
    // useEffect(() => {
    //     if (erpProducts.length > 0) {
    //         const tmp = [];
    //         for (let p of erpProducts) {
    //             var tmp2 = {};
    //             for (let r of p.recipes) {
    //                 const rec = getERPrecipe(r.id);
    //                 if (!rec.code_3d) {
    //                     console.log(rec)
    //                     tmp2[rec.type] = rec.name
    //                 }
    //             }
    //             if (Object.keys(tmp2).length === 0) {
    //                 tmp.push({ name: p.name, ...tmp2 })
    //             }
    //         }
    //         console.log(tmp)
    //     }
    // }, [erpProducts]);



    function initMaterialsERP(parameters, db) {
        for (let [k, v] of Object.entries(colorMaterials.default)) {
            // console.log(db)
            var rtn = {};
            const colorERP = findPartByCode("colors", v, db)?.dataERP;
            // console.log(findPartByCode("colors", v, db))
            // const colorName = colorERP?.label?.en;
            const colorName = colorERP?.code_3d;
            rtn.code = v;
            const paramName = getGoodName(k, true);
            if (paramName) {
                for (let p of parameters) {
                    if (p.name === paramName) {
                        rtn.parameter_id = p.id;
                        if (colorName) {
                            let tmpValid = false;
                            for (let pc of p.values) {
                                // console.log(pc.color?.code_3d, colorName)
                                if (pc.color?.code_3d === colorName) {
                                    rtn.parameter_value_id = pc.id;
                                    tmpValid = true;
                                    break;
                                }
                            }
                            if (!tmpValid) {
                                rtn.parameter_value_id = null;
                            }
                        } else {
                            rtn.parameter_value_id = null;
                            break;
                        }
                        break;
                    }
                }
            } else {
                rtn.parameter_id = null;
                rtn.parameter_value_id = null;
            }
            // get();
            colorMaterials.default[k] = rtn
        }
    }

    function dbWithPhotos(db) {
        const currentUrl = urlShort + "/images/elements";
        var rtn = db;
        rtn.builds.map((b) => {
            b.imgUrl = currentUrl + "/builds/" + b.code + ".png"
        })
        rtn.lampshades.map((s) => {
            s.imgUrl = currentUrl + "/lampshades/" + s.code + ".png"
        })
        rtn.canopy.map((c) => {
            c.imgUrl = currentUrl + "/canopies/" + c.code + ".png"
        })
        rtn.colors.map((col) => {
            if (col.image === "true") {
                col.imgUrl = currentUrl + "/thumbnails/" + col.code + ".jpg"
            } else {
                col.imgUrl = null;
            }
        })
        rtn.background.map((bg) => {
            bg.imgUrl = urlShort + "/env3d/" + bg.code + ".jpg"

        })

        return rtn;
    }

    function makeCurrMtl(mtlM) {
        mtlM.map((el) => {
            if (colorMaterials.curr[el] === undefined) {
                // console.log(colorMaterials.default[el]);
                colorMaterials.curr[el] = colorMaterials.default[el];
                //Object.assign(colorMaterials.curr[el],colorMaterials.default[el]);
            }
        })
    }

    // All events handlers
    const [mtl, setMtl] = useState([]);

    const OnModelBegin = () => {
        //console.log('model begin!');
        urlMode.includes('product') && window.parent.postMessage({ isLoading: 'true' }, "*"); // Components array for product page
        setTheLoading(true)
    };

    //const [tmpModel,setTmpModel] = useState();

    // const [modelEndEvt, setModelEndEvt] = useState(null);

    // useEffect(() => {
    //     console.log(modelEndEvt)
    //     if (modelEndEvt !== null) {
    //         //OnModelEnd(modelEndEvt);
    //     }
    // }, [modelEndEvt]);

    const OnModelEnd = (evt) => {
        //console.log(evt.detail);
        //variationNum++;
        const e = evt.detail;
        var tmpArray = [...e.components];
        var tmpArray2 = [...e.components];
        const tmpC = [...e.components];

        let ze = transformExt(tmpC);
        // console.log(ze)
        mapERP[ze.curr] = mapERP[ze.ext]

        comp3D = tmpC;
        // if (tmpC.includes("exterior3") && (tmpC.includes("exterior2") || tmpC.includes("terrazzo"))) {
        //     mapERP["abatjour.couleur.ext_haut"] = "exterior3"
        // } else {
        //     mapERP["abatjour.couleur.ext_haut"] = "exterior2"
        // }
        updateModelMtls(tmpModel, tmpC);
        // console.log(tmpModel)
        // console.log(modelMtls)

        //const index = tmpArray.indexOf("stem2");
        //tmpArray = tmpArray.splice(index,1);
        //tmpArray2 = tmpArray2.splice(index,1);
        tmpArray.sort(function (a, b) {
            return sortOrder.indexOf(a) - sortOrder.indexOf(b);
        });
        tmpArray2.sort(function (a, b) {
            return sortOrderProduct.indexOf(a) - sortOrderProduct.indexOf(b);
        });
        // if (urlCode === null) {
        const c = e.canopy === undefined || e.canopy === "none" ? {} : findPartByCode("canopy", e.canopy);
        const s = e.stem === undefined || e.stem === "none" ? {} : findPartByCode("stem", e.stem);
        //const v = e.stem === undefined && e.stem === "none" ? {} : findPartByCode("stem", e.stem);
        // console.log(e.canopy);
        currCanopy.data = c;
        currStem.data = s;
        //}
        //console.log(tmpArray);

        urlMode.includes('product') && window.parent.postMessage({ components: tmpArray2 }, "*")   // Components array for product page
        urlMode.includes('product') && window.parent.postMessage({ isLoading: 'false' }, "*");     // Components array for product page

        //if (e.components.length > 0 || urlCode !== null) {
        makeCurrMtl(tmpArray)
        setMtl(tmpArray);
        if (setProductUrl > 1 && urlMode.includes('product')) {
            setTheLoading(false);
        } else if (!urlMode.includes('product')) {
            setTheLoading(false);
        }
        //}
        //console.log(variationNum)
        /**if(variationNum==1){
            //console.log("AFSfas")
            callVariation(model,i);
            variationNum = 0;
        }*/
        //callVariation(model,i);
        //console.log("END!");
        //setTmpModel(model.build);

        if (urlCode !== null) {
            /*if (setPurl === 0) {
                setPurl++;
            }*/
        }
        if (urlMode.includes('product')) {
            if (setProductUrl < 2) {
                setProductUrl++;
            }
        }
        // console.log('model end!');
    };

    const OnMaterialBegin = () => {
        // console.log('mtl begin!');
        setLoadMtlScreen(true)
    };
    const OnMaterialEnd = () => {
        // console.log('mtl end!');
        //if(mtl.length > 0 || urlCode !== null){
        setLoadMtlScreen(false);
        //}
        //console.log(loadScreen);
    };

    const [isResetAll, setIsResetAll] = useState(false);
    const [resetNum, setResetNum] = useState(0);

    const restBtnRef = useRef([]);

    function resetAll() {
        setOnMakingModel(true);
        setResetNum(1);

    }

    useEffect(() => {
        if (resetNum == 1) {
            var id = 0;
            const interval = setInterval(() => {
                if (id === 0) {
                    restBtnRef.current.click();
                    //tmpVariation = id;
                } else if (id === 1) {
                    buildRef.current[model.build.id]?.click();
                } else if (id === 2) {
                    lampshadeRef.current[model.lampshade.id]?.click();
                } else if (id === 3) {
                    setIsResetAll(false);
                    setCurrentBGid(null);
                    setMenuEnv3D(true);
                    iframe?.contentWindow.postMessage({
                        integration: { mode: 'normal', name: '' },
                    });
                    setOnMakingModel(false)
                    setResetNum(0)
                    clearInterval(interval)
                }
                id++;

            }, 50);

            return () => clearInterval(interval);
        }
    }, [resetNum]);



    // ----------------------------------------------------------------------- Print page
    const [sImg, setSimg] = useState('./images/logo.png');
    const [bImg, setBimg] = useState(false);

    const OnScreenshot = (evt) => {
        setBimg(true);
        console.log(evt.detail)
        setSimg(evt.detail.img);
    };

    const OnThumbnail = (evt) => {
        console.log(evt.detail)
        var image = evt.detail.img;
        var imageDim = evt.detail.imgDim;
        // var w = window.open("");
        // w.document.write('<img src="' + image + '" />');
        setThumb(image);
        window.parent.postMessage({ thumbnailImage: image }, "*");
        if (urlMode.includes('productsThumb')) {
            const error = thumbError;
            setCodeFromModel();
            const thumbCode = String(code.join(''))
            const zeLink = window.location.href.split('?')[0] + "?code=" + thumbCode;
            // console.log(thumbError)
            window.dispatchEvent(new CustomEvent("thumbnail-ready", { detail: { image, imageDim, error, code: { code: thumbCode, url: zeLink }, requestId: evt.detail.requestId } }));
            productIframe.contentWindow.postMessage({
                hide: true,
            })
        }
    };

    function OnMaterialChange(evt) {
        const [k, v] = Object.entries(evt.detail)[0];

        const d = colorMaterials.default[k];
        if (!colorMaterials.curr[k]) {
            colorMaterials.curr[k] = { parameter_id: d?.parameter_id };
        }
        let c = colorMaterials.curr[k];
        const pid = getERPmtlParamIDbyCode(c?.parameter_id || d?.parameter_id, v)
        c.code = v;
        c.parameter_value_id = pid;
        // console.log(colorMaterials.curr[k], c)
        if (colorMaterials.prev[k]) {
            const p = colorMaterials.prev[k];
            p.code = v;
            p.parameter_value_id = pid;
        }
        // }
    }

    useEffect(() => {
        //if(iframe !== null){
        //console.log(iframe);
        if (iframe && setPurl < 2) {
            setPurl++;
        }
        iframe?.contentWindow.addEventListener("OnModelBegin", OnModelBegin, false);
        iframe?.contentWindow.addEventListener("OnMaterialBegin", OnMaterialBegin, false);
        iframe?.contentWindow.addEventListener("OnModelEnd", OnModelEnd, false);
        iframe?.contentWindow.addEventListener("OnMaterialEnd", OnMaterialEnd, false);
        iframe?.contentWindow.addEventListener("OnScreenshot", OnScreenshot, false);
        iframe?.contentWindow.addEventListener("OnThumbnail", OnThumbnail, false);
        iframe?.contentWindow.addEventListener("OnMaterialChange", OnMaterialChange, false);
        return () => {
            iframe?.contentWindow.removeEventListener("OnModelBegin", OnModelBegin, false);
            iframe?.contentWindow.removeEventListener("OnMaterialBegin", OnMaterialBegin, false);
            iframe?.contentWindow.removeEventListener("OnModelEnd", OnModelEnd, false);
            iframe?.contentWindow.removeEventListener("OnMaterialEnd", OnMaterialEnd, false);
            iframe?.contentWindow.removeEventListener("OnScreenshot", OnScreenshot, false);
            iframe?.contentWindow.removeEventListener("OnThumbnail", OnThumbnail, false);
            iframe?.contentWindow.removeEventListener("OnMaterialChange", OnMaterialChange, false);
        }
        //}
    }, [iframe]);

    const [getURL, setGetURL] = useState(false);
    const [zeUrlCode, setZeUrlCode] = useState();
    const [zeUrlLang, setZeUrlLang] = useState("fr");
    const [zeThumbnail, setZeThumbnail] = useState();

    // --------------------- PRODUCT PAGE Events ------------------------ //
    useEffect(() => {
        //if(iframe !== null){
        //console.log(productIframe);


        productIframe?.contentWindow.addEventListener("OnModelBegin", OnModelBegin, false);
        productIframe?.contentWindow.addEventListener("OnMaterialBegin", OnMaterialBegin, false);
        productIframe?.contentWindow.addEventListener("OnModelEnd", OnModelEnd, false);
        productIframe?.contentWindow.addEventListener("OnMaterialEnd", OnMaterialEnd, false);
        productIframe?.contentWindow.addEventListener("OnScreenshot", OnScreenshot, false);
        productIframe?.contentWindow.addEventListener("OnThumbnail", OnThumbnail, false);
        productIframe?.contentWindow.addEventListener("OnMaterialChange", OnMaterialChange, false);

        // Thumbnail from backend!
        const updateSceneHandler = (e) => {
            // console.log(e.detail)
            const { parameters, productID, size, hasDimensions, requestId } = e.detail;
            const cParams = transformParamsFromERP(parameters);
            productIframe.contentWindow.postMessage({
                hide: false,
            })
            async function loadProduct() {
                await setProductByID(productID, true).then((el) => {
                    console.log(el, cParams)
                    productIframe.contentWindow.postMessage({ getThumbnailERP: { x: size, y: size, parameters: cParams, product: { build: el.build, lampshade: el.lampshade }, hasDimensions, requestId }, });
                });
            }
            loadProduct();
            // console.log(cParams)

        };

        // --------------------------------- Message for product page
        if (productIframe !== null) {

            window.addEventListener('makeModelFromPost', updateSceneHandler);

            window.addEventListener('message', function (e) {
                // console.log(e.data)
                if (e.data.material) { // set Materials
                    const { component, material } = e.data.material;
                    // console.log(comp3D);
                    const goodname = isAnyUpper(component) ? getGoodName(component, false, comp3D, true) : component;
                    if (!colorMaterials.curr[goodname]) {
                        colorMaterials.curr[goodname] = {}
                    }
                    colorMaterials.curr[goodname].code = material;
                    productIframe.contentWindow.postMessage({
                        material: {
                            type: goodname,
                            color: material
                        }
                    })
                } else if (e.data.focusComponent) { // set zoom (focus) on current component
                    const { component } = e.data.focusComponent;
                    const goodname = isAnyUpper(component) ? getGoodName(component, false, comp3D, true) : component;
                    // console.log(goodname);
                    productIframe.contentWindow.postMessage({ focusComponent: { component: goodname } }, "*");
                } else if (e.data.printPDF) {
                    printPage(true);
                    //window.parent.postMessage({apiDB:data}, "*");                
                } else if (e.data.getUrlCode) {
                    // console.log("asf")
                    setZeUrlLang(e.data.getUrlCode)
                    setCodeFromModel();
                    setGetURL(prevGetURL => !prevGetURL);
                    // setUrlType(e.data.customize);
                    //window.parent.postMessage({apiDB:data}, "*");
                } else if (e.data.stem) {
                    //console.log(e.data.stem)
                    productIframe.contentWindow.postMessage({ stem: { height: e.data.stem.type }, });
                    //window.parent.postMessage({apiDB:data}, "*");
                } else if (e.data.canopy) {
                    //console.log(e.data.canopy)
                    const { type } = e.data.canopy;
                    const goodname = isAnyUpper(type) ? getGoodCanopy(type) : type;
                    productIframe.contentWindow.postMessage({ canopy: { type: goodname }, });
                    //window.parent.postMessage({apiDB:data}, "*");
                } else if (e.data.makeThumbnail) {
                    const size = e.data.makeThumbnail;
                    // console.log(size)
                    productIframe.contentWindow.postMessage({ getThumbnail: size, });
                    //window.parent.postMessage({apiDB:data}, "*");
                }
            }, false);

        }

        return () => {
            productIframe?.contentWindow.removeEventListener("OnModelBegin", OnModelBegin, false);
            productIframe?.contentWindow.removeEventListener("OnMaterialBegin", OnMaterialBegin, false);
            productIframe?.contentWindow.removeEventListener("OnModelEnd", OnModelEnd, false);
            productIframe?.contentWindow.removeEventListener("OnMaterialEnd", OnMaterialEnd, false);
            productIframe?.contentWindow.removeEventListener("OnScreenshot", OnScreenshot, false);
            productIframe?.contentWindow.removeEventListener("OnThumbnail", OnThumbnail, false);
            productIframe?.contentWindow.removeEventListener("OnMaterialChange", OnMaterialChange, false);
            window.removeEventListener('makeModelFromPost', updateSceneHandler);
        }
        //productIframe?.console.log(productIframe?.contentWindow);
        //}

    }, [productIframe, thumbError]);

    function transformParamsFromERP(elements) {
        let rtn = [];
        for (let el of elements) {
            const param = getERPparametersByID(el.id)
            // const colorType = (param.name.includes("Type") || param.name.includes("Long")) ? getGoodName(param.name) : getGoodName(param.name, false, comp3D, true);
            const colorType = getGoodName(param.name);
            // console.log(colorType, param.name, comp3D)
            const code = getERPmtlParamByID(el.id, el.valueID);
            const otherCode = colorType === "canopyType" ? getGoodCanopy(code?.name) : colorType === "stemLen" ? code?.name || 8 : null;
            rtn.push({ type: colorType, section: param.section, value: code?.color?.code_3d || otherCode })
        }
        return rtn;
    }

    // get thumbnail image
    // useEffect(() => {
    //     // console.log(zeUrlCode);
    //     if (zeUrlCode) {
    //         window.parent.postMessage({ thumbnailImage: zeUrlCode }, "*");
    //         setZeUrlCode();
    //     }
    // }, [zeUrlCode]);

    // get product URL
    useEffect(() => {
        // console.log(zeUrlCode);
        if (zeUrlCode) {
            window.parent.postMessage({ urlCode: zeUrlCode }, "*");
            setZeUrlCode();
        }
    }, [zeUrlCode]);

    function printPage(force = false) {
        if (validCombination || force) {
            setPDFVisible(true);
            setCurrType()
            setCodeFromModel()
            setSideOpened(null);
            const i = urlMode.includes('product') ? document.getElementById("productIframe").contentWindow : document.getElementById("appIframe").contentWindow;
            i.postMessage({
                takePhoto: ''
            })
        }
    }
    // function printThumb(size = { x: 150, y: 150 }) {
    //     if (validCombination) {
    //         const i = urlMode.includes('product') ? document.getElementById("productIframe").contentWindow : document.getElementById("appIframe").contentWindow;
    //         i.postMessage({
    //             getThumbnail: { size }
    //         })
    //     }
    // }

    function modelByCode(part, code) {
        var val = null;
        data[part].map((el) => {
            if (el.code === code) {
                val = el;
                return false;
            }
            return false;
        });
        return val;
    }

    // -------------- On start -------------- //
    useEffect(() => {
        if (setProductUrl === 2) {
            setProductByID(urlParams.get('productID'))
        }
    }, [setProductUrl]);

    function setProductByID(pID, isThumbnail = false) {
        return new Promise((resolve, reject) => {
            var id = 0;
            const ifr = productIframe.contentWindow;
            //productIframe?.contentWindow.postMessage({transparentBG:{bg:'true'}}, "*");
            const pro = pID ? transformProductERP(pID, erpProducts, erpRecipes) : null;
            let bCode, lCode;

            const interval = setInterval(() => {
                if (id == 0) {
                    bCode = pID ? pro?.build?.code_3d : urlParams.get('build')
                    if (bCode !== null) {
                        setTheLoading(true);
                        const b = modelByCode('builds', bCode);
                        // console.log(b)
                        if (b) {
                            var goodName = b.name;
                            if (b.dataERP) {
                                goodName = b.dataERP.name;
                            }
                            // console.log(goodName);
                            productID.build = b.id;
                            setModel(pmodel => ({ ...pmodel, build: { model: b.code, title: goodName, id: b.id, data: b } }));
                            if (!isThumbnail) {
                                ifr.postMessage({
                                    build: bCode,
                                })
                            }
                        } else {
                            setThumbError(true);
                            console.log('\x1b[33m%s\x1b[0m \x1b[0m%s\x1b[0m \x1b[31m%s\x1b[0m', "No Build's model found!", '|', 'Model: ' + urlParams.get('build'))
                        }
                        // variationNum = 1;
                    }
                } else if (id == 1) {
                    lCode = pID ? pro?.lampshade?.code_3d : urlParams.get('lampshade');
                    if (lCode !== null) {
                        setTheLoading(true);
                        const l = modelByCode('lampshades', lCode);
                        if (l) {
                            var goodName = l.name;
                            if (l.dataERP) {
                                goodName = l.dataERP.name;
                            }
                            productID.lampshade = l.id;
                            setModel(pmodel => ({ ...pmodel, lampshade: { model: l.code, title: goodName, id: l.id, data: l } }));
                            if (!isThumbnail) {
                                ifr.postMessage({
                                    lampshade: lCode,
                                })
                            }
                        } else {
                            setThumbError(true);
                            console.log('\x1b[33m%s\x1b[0m \x1b[0m%s\x1b[0m \x1b[31m%s\x1b[0m', "No Lampshade's model found!", '|', 'Model: ' + urlParams.get('lampshade'))
                        }
                        // variationNum = 1;
                    }
                    if (!lCode && !bCode) {
                        console.warn('\x1b[31m%s\x1b[0m', 'ProductID ' + pID + " doesn't exist");
                    }

                } else {
                    // ✅ On considère le chargement terminé après l’étape 1
                    clearInterval(interval);
                    resolve({ build: bCode, lampshade: lCode });
                }
                id++;
            }, 50);
        });
    }

    // END --------------------------------------------------------------------- Print page


    const [sideOpened, setSideOpened] = useState(null);
    const [model, setModel] = useState({ build: { model: "", title: "", id: null, data: null }, lampshade: { model: "", title: "", id: null, data: null } });
    tmpModel = model;
    const [b, setB] = useState(""); // set temp build value
    const [l, setL] = useState(""); // set temp lampshade value
    const [b2, setB2] = useState(""); // set temp build value
    const [l2, setL2] = useState(""); // set temp lampshade value
    const [filteredID, setFilteredID] = useState({ build: [], lampshade: [] });
    const [validCombination, setValidCombination] = useState(false);

    const [currType, setCurrType] = useState();

    function initFilters(isPro = false) {
        if (isPro) {
            const iframe = document.getElementById('productIframe')
            setProductIframe(iframe);
            const dragFrame = window.frames["productIframe"].contentDocument.getElementById("dragPage")
            //console.log(document.getElementById('appIframe'));
        } else {
            const iframe = document.getElementById('appIframe')
            setIframe(iframe);
            const dragFrame = window.frames["appIframe"].contentDocument.getElementById("dragPage")
            // console.log(window.frames["appIframe"].contentDocument.getElementById("loadingModel"))
            //dragFrame.style.backgroundColor = "#efefefd8";
        }

        var bA = [];
        var lA = [];
        data.builds.map((el) => {
            bA.push(el.id);
            return false;
        })
        data.lampshades.map((el) => {
            lA.push(el.id);
            return false;
        })
        setFilteredID({ ...filteredID, build: bA, lampshade: lA });

    }

    useEffect(() => {
        if (!sideOpened && iframe?.contentWindow) {
            iframe.contentWindow.postMessage({
                focusComponent: { component: "global" }
            });
        }
    }, [sideOpened])

    useEffect(() => {
        var i = iframe !== null ? iframe.contentWindow : "";
        validCombinationF();
        if (i !== "") {
            dc = structuredClone(data.colors);
            // console.log(dc);
            //setDC(structuredClone(data.colors));
            if (l !== model.lampshade.model) {
                //Object.assign(modelMtls, model.lampshade.data?.materials,model.lampshade.data?.materials);
                //console.log(modelMtls);
                // mtlPrice(model);
                if (filteredID.lampshade.includes(model.lampshade.id)) {
                    const zeL = model.lampshade.model === "" ? "none" : model.lampshade.model;
                    setL(model.lampshade.model);
                    //console.log('post lampshade: ' + zeL);

                    i.postMessage({
                        lampshade: zeL,
                    })
                    // variationNum = 1;
                    // if (model.build.data?.stemheights.length > 0) {
                    //     model.build.data.stemheights.some((el) => {
                    //         if (el.lampshade == model.lampshade.id) {
                    //             console.log(el.stemHeight)
                    //             setStemTimer(el.stemHeight);
                    //             //callVariation(model,i);
                    //         }
                    //     })
                    // }
                } else {
                    setL("none");
                    //console.log('post lampshade: NONE');
                    i.postMessage({
                        lampshade: "none",
                    })
                }

            }
            if (b !== model.build.model) {
                // mtlPrice(model);

                // console.log(model.build.model);
                if (filteredID.build.includes(model.build.id)) {
                    // const zeB = model.build.model === "" ? "none" : model.build.model;
                    setB(model.build.model);
                    if (colorMaterials.curr !== undefined) {
                        Object.keys(colorMaterials.curr).map(function (el) {
                            // console.log(el);
                            if (el === "canopy" || el === "stem" || el === "wire") {
                                validationMaterial(el, model)
                            }
                        })
                    }
                } else {
                    setB("none");
                }
            }
            // Object.assign(modelMtls, model.build.data?.materials, model.lampshade.data?.materials);
            /* const objCombiner = () => {
                 // var rtn = { ...model.build.data?.materials, ...model.lampshade.data?.materials };
                 var rtn = {};
                 var buildMtl = mtlToParams(model.build.data?.materials);
                 var lampMtl = mtlToParams(model.lampshade.data?.materials);
                 if (model.build.data?.dataERP?.params.length > 0) {
                     buildMtl = getERPmtlByRecipe(model.build.data.dataERP.params);
                     // console.log(buildMtl);
                 }
                 if (model.lampshade.data?.dataERP?.params.length > 0) {
                     lampMtl = getERPmtlByRecipe(model.lampshade.data.dataERP.params);
                 }
                 if (model.lampshade.data?.dataERP?.params.length > 0 && model.build.data?.dataERP?.params.length > 0) {
                     // setCurrParameters()
                 }
                 rtn = { ...buildMtl, ...lampMtl };
                 // console.log(buildMtl);
                 if (model.build.data) {
                     for (let [i, o] of Object.entries(buildMtl)) {
                         // console.log(i, o);
 
                         if (model.lampshade.data) {
                             const ls = lampMtl[i];
                             if (ls) {
                                 var tmp = [...o, ...ls];
                                 rtn[i] = tmp;
                             }
                         }
                     }
                 }
                 return rtn;
             }
             modelMtls = objCombiner();*/
            // updateModelMtls()

            // console.log(modelMtls);

            // setVariationTimer(model)
            //setStemTimer(model);
        }
    }, [model]);

    function updateModelMtls(tmpModel, comp) {
        // var rtn = { ...model.build.data?.materials, ...model.lampshade.data?.materials };
        var rtn = {};
        var buildMtl = mtlToParams(tmpModel.build.data?.materials);
        var lampMtl = mtlToParams(tmpModel.lampshade.data?.materials);
        // console.log(tmpModel);
        if (tmpModel.build.data?.dataERP?.params.length > 0) {
            buildMtl = getERPmtlByRecipe(tmpModel.build.data.dataERP.params, comp);
            // console.log(buildMtl);
        }
        if (tmpModel.lampshade.data?.dataERP?.params.length > 0) {
            lampMtl = getERPmtlByRecipe(tmpModel.lampshade.data.dataERP.params, comp);
            // console.log(tmpModel);
        }
        if (tmpModel.lampshade.data?.dataERP?.params.length > 0 && tmpModel.build.data?.dataERP?.params.length > 0) {
            // setCurrParameters()
        }
        rtn = { ...buildMtl, ...lampMtl };
        // console.log(buildMtl);
        if (tmpModel.build.data) {
            for (let [i, o] of Object.entries(buildMtl)) {
                // console.log(i, o);

                if (tmpModel.lampshade.data) {
                    const ls = lampMtl[i];
                    if (ls) {
                        var tmp = [...o, ...ls];
                        rtn[i] = tmp;
                    }
                }
            }
        }
        // console.log(lampMtl)
        modelMtls = rtn;
    }

    function mtlToParams(mtl) {
        // console.log(mtl);
        var rtn = {};
        if (mtl) {
            for (let [k, p] of Object.entries(mtl)) {
                rtn[k] = [];
                for (let i of p) {
                    rtn[k].push({ id: i, parameter_id: null, parameter_value_id: null });
                }
            }
        }
        return rtn;
    }

    function transformERPcolors(arr, comp) {
        // console.log(arr);
        // console.log(data);
        var erpData = {};
        for (let [ia, a] of Object.entries(arr)) {
            // console.log(arr)
            const name = getGoodName(a.parent.name, false, comp)
            // console.log(name);
            if (!erpData[name]) {
                erpData[name] = [];
            }
            // console.log(a)
            var tmpArr = [];
            for (let aC of a.child.values) {
                const aID = aC.id;
                // const aP = a.parent;
                for (let aP of a.parent.values) {
                    if (aP.id === aID) {
                        // console.log(aP)
                        tmpArr.push({ code_3d: aP.color?.code_3d || aP.finition?.code_3d, paramID: aID });
                    }
                }
            }

            // console.log(tmpArr,data.colors);
            for (let c of data.colors) {
                // console.log(c.dataERP)
                // const zeID = c.dataERP?.label?.en || c.dataERP?.name?.en;
                const zeID = c.dataERP?.code_3d;
                if (!zeID) {
                    // console.warn(c.code);
                }
                for (let d of tmpArr) {
                    if (d.code_3d === zeID && zeID) {
                        // console.log(d.name, d.paramID);
                        erpData[name].push({ id: c.id, parameter_id: a.parent.id, parameter_value_id: d.paramID });
                    }
                }

            }

        }
        // console.log(erpData)
        return erpData;
    }

    function getERPmtlByRecipe(data, comp) {
        // var rtn;
        var tmp = [];
        for (let d of data) {
            const param = getERPparametersByID(d.id);
            // console.log(d, param);
            if (param.type === "color" || param.type === "finition") {
                tmp.push({ parent: param, child: d })
            }
        }
        return transformERPcolors(tmp, comp);
    }

    function getERPmtlParamByID(pID, id) {
        var rtn;
        const param = getERPparametersByID(pID);
        // console.log(pID)
        if (param?.values) {
            rtn = param.values[0];
            for (let e of param.values) {
                if (e.id === id) {
                    rtn = e;
                }
            }
        }
        return rtn;
    }
    function getERPmtlParamIDbyCode(pID, code) {
        var rtn;
        const param = getERPparametersByID(pID);
        // console.log(pID)
        if (param?.values) {
            for (let e of param.values) {
                if (e.color) {
                    if (e.color.code_3d === code) {
                        rtn = e.id;
                    }
                } else if (e.finition) {
                    if (e.finition.code_3d === code) {
                        rtn = e.id;
                    }
                }
            }
        }
        return rtn;
    }

    function getERPparametersByID(id) {
        var rtn;
        for (let erpP of erpParameters) {
            if (erpP.id === id) {
                rtn = erpP;
            }
        }
        return rtn;
    }

    // -------------------------------------------------------------------- Set variation
    function callVariation(zeModel) {
        //console.log(zeModel)
        var i = iframe !== null ? iframe.contentWindow : "";
        if (zeModel?.build.data?.modeloptions.length > 0) {
            var tmpNum = zeModel.build.data.modeloptions.length;
            zeModel.build.data.modeloptions.some((el) => {
                tmpNum--;
                if (el.lampshades.includes(model.lampshade.id)) {
                    //console.log(el.code,model.build.model)
                    //if (currVariation.data?.code !== el.code) {
                    currVariation.data = el;
                    // console.log(el.code);
                    i.postMessage({
                        variation: el.code,
                    })
                    return true
                    //}
                }
                if (tmpNum < 0) { // Reset to first if no model found
                    currVariation.data = model.build.data.modeloptions[0];
                    return true
                }
                return false
            })
        } else {
            currVariation.data = {};
        }
        if (zeModel?.build.data?.stemheights.length > 0) {
            zeModel.build.data.stemheights.some((el) => {
                if (el.lampshade == model.lampshade.id) {
                    console.log(el.stemHeight)
                    i.postMessage({
                        stem: { height: String(el.stemHeight), isCustom: true }
                    });

                    //callVariation(model,i);
                }
            })
        }
    }

    // const [variationTimer, setVariationTimer] = useState()

    // -------------------------------------- Tweak
    // useEffect(() => {
    //     //console.log(variationNum);
    //     if (variationNum == 1) {

    //         const timeVar = variationNum2 == 0 ? 1000 : 10;
    //         const timeout = setTimeout(() => {
    //             //setShow(true)
    //             callVariation(variationTimer)
    //             variationNum2 = 1;
    //         }, timeVar)

    //         return () => clearTimeout(timeout)
    //     }

    // }, [variationTimer])

    // -----------------------------------------------------------------------------------
    // function mtlPrice(zeModel) {
    //     var mtlArray = [];
    //     const arrBuild = zeModel.build.data ? zeModel.build.data.mtlsPrice : [];
    //     const arrLampshade = zeModel.lampshade.data ? zeModel.lampshade.data.mtlsPrice : [];
    //     mtlArray = mtlArray.concat(arrBuild, arrLampshade);

    //     mtlArray.map((e) => {
    //         dc.map((DCe) => {
    //             if (!DCe.categories.includes(e.type) && DCe.id === e.colorID) {
    //                 DCe.categories.push(e.type);
    //             }
    //         })
    //     })
    // }

    useEffect(() => {
        var i = iframe !== null ? iframe.contentWindow : "";
        if (i !== "") {
            if (filteredID.build.includes(model.build.id)) {
                const zeB = model.build.model === "" ? "none" : model.build.model;
                i.postMessage({
                    build: zeB,
                })
                // variationNum = 1;
                //callVariation(model,i);
            } else {
                i.postMessage({
                    build: "none",
                })
            }
            setRequired({ ...required, options: false });
            setPreSubmit(false);
        }
    }, [b]);

    useEffect(() => {
        const req = Object.values(required);
        if (!req.includes(false)) {
            setPreSubmit(false);
        }
    }, [required])


    // Set 3D model in the viewer
    function set3dModel(obj) {
        setModel(obj);
        if (b2 !== obj.build.model) {
            setB2(obj.build.model);
            setFilter("build", obj);
        }
        if (l2 !== obj.lampshade.model) {
            //console.log(l,obj.lampshade.model);  
            setL2(obj.lampshade.model);
            setFilter("lampshade", obj);
        }
    }

    // Check if material is compatible -> set to default if not
    function validationMaterial(type, mod) {
        const isAK = mod.build.model.includes('AK') ? " AK" : "";
        const type2 = type + isAK
        const i = iframe.contentWindow;
        dc.map(function (e) {
            if (e.code === colorMaterials.curr[type].code) {
                //console.log(colorMaterials.curr[type]);
                if (type === "wire") {
                    const isBraided = e.code.slice(0, 2) === "T.";
                    //const currBraided = e.code.slice(0, 2) === "T.";
                    const mode = mod.build.data.wireopt;
                    const showWire = mode === 'simple' ? !isBraided : mode === 'braided' ? isBraided : true;
                    //console.log(showWire);
                    if (!showWire) {
                        const goodWire = mode === 'braided' ? "T." + colorMaterials.default[type].code : colorMaterials.default[type].code;
                        colorMaterials.curr[type].code = goodWire;
                        if (colorMaterials.prev[type]) {
                            colorMaterials.prev[type].code = goodWire;
                        }
                        i.postMessage({
                            material: { type: type, color: colorMaterials.default[type].code },
                        });
                        i.postMessage({
                            acceptMaterials: true,
                        });
                    }
                } else {
                    if (!e.categories.includes(type2)) {

                        colorMaterials.curr[type].code = colorMaterials.default[type].code;
                        colorMaterials.prev[type].code = colorMaterials.default[type].code;
                        i.postMessage({
                            material: { type: type, color: colorMaterials.default[type].code },
                        });
                        i.postMessage({
                            acceptMaterials: true,
                        });
                    }
                }
            }
        });
    }

    function getERPrecipe(id) {
        var rtn;
        for (let d of erpRecipes) {
            if (d.id === id) {
                rtn = d;
            }
        }
        return rtn;
    }

    function getERPcombinationsIDs(el, type) {
        var erpTmp = [];
        if (el.dataERP) {
            for (let eP of el.dataERP.products) {
                const erpP = eP.recipes;
                const code = () => {
                    const arr = [];
                    for (let p of erpP) {
                        const rcp = getERPrecipe(p.id);
                        if (rcp.type === type) {
                            // console.log(i2, type)
                            arr.push(rcp.code_3d)
                        }
                    }
                    return arr;
                }
                const zeCode = code();

                if (zeCode.length > 0) {
                    for (let mc of zeCode) {
                        const toPush = modelByCode(type + "s", mc)?.id;
                        if (toPush) {
                            if (erpTmp.indexOf(toPush) === -1) {
                                erpTmp.push(toPush);
                            }
                        }
                    }
                }
            }
        }
        return erpTmp;
    }

    // Filter (where you can select a build and/or a lampshade => #combinations)
    function setFilter(type, obj) {
        var bA = [];
        var lA = [];
        // If is BUILD
        if (type === "build") {
            if (obj.build.model !== "") {
                if (obj.lampshade.model !== "") {
                    //setValidCombination(true);
                    data.builds.map((el) => {
                        // const tmpL = getERPcombinationsIDs(el, "lampshade");

                        // if (el.id === obj.lampshade.id) {
                        //     console.log(el, bA)
                        // }
                        const tmpL = getERPcombinationsIDs(el, "lampshade")
                        if (tmpL.includes(obj.lampshade.id)) {
                            // console.log(tmpL, obj.lampshade.id)
                            bA.push(el.id);
                            //return false;
                        }

                        if (el.id === obj.build.id) {
                            // const tmpB = getERPcombinationsIDs(el, "build");
                            // bA.push(...tmpB)
                            // console.log(el);
                            if (el.dataERP?.products.length > 0) {
                                // if ERP has products
                                lA = getERPcombinationsIDs(el, "lampshade");
                            } else { // use edge's data                                
                                lA = el.lampshades;
                            }
                        }
                        return false;
                    })
                } else {
                    data.builds.map((el) => {
                        bA.push(el.id);
                        if (el.id === obj.build.id) {
                            // console.log(el.id)
                            const tmpB = getERPcombinationsIDs(el, "build");
                            // bA.push(el.id)
                            if (el.dataERP?.products.length > 0) {
                                // if ERP has products
                                lA = getERPcombinationsIDs(el, "lampshade");
                            } else { // use edge's data                                
                                lA = el.lampshades;
                            }
                            return false
                        }
                    })
                }
            } else {
                //setValidCombination(false);
                if (obj.lampshade.model !== "") {
                    data.builds.map((el) => {
                        console.log(el)
                        const tmpL = getERPcombinationsIDs(el, "lampshade")
                        if (tmpL.includes(obj.lampshade.id)) {
                            // console.log(tmpL, obj.lampshade.id)
                            bA.push(el.id);
                            //return false;
                        }
                        return false;
                    })
                } else {
                    data.builds.map((el) => {
                        bA.push(el.id);
                        return false;
                    })
                }
                data.lampshades.map((el) => {
                    lA.push(el.id);
                    return false;
                })
            }
            // if is LAMPSHADE is selected 
        } else {
            if (obj.lampshade.model !== "") {
                data.lampshades.map((el) => {
                    // lA.push(el.id)
                    if (el.id === obj.lampshade.id) {
                        const tmpB = getERPcombinationsIDs(el, "build");
                        bA.push(...tmpB)
                        // console.log(el, bA)
                    }

                });
                /*data.builds.map((el) => {
                    if(true){
                        console.log(obj)
                    }
                    // console.log(el.lampshades);
                    // if (el.lampshades) {
                        //     // bA.push(el.id);
                        //     //return false;
                        // }else if(el.lampshades.includes(obj.lampshade.id)){

                        // }
                        if (obj.build.model !== "") {
                        if (el.id === obj.build.id) {
                            // lA = el.lampshades;
                            if (el.dataERP?.products.length > 0) {
                                // if ERP has products
                                lA = getERPcombinationsIDs(el, "lampshade");
                            } else { // use edge's data                                
                            lA = el.lampshades;
                        }
                    }
                }
                return false;
            })*/
                if (obj.build.model === "") {
                    data.lampshades.map((el) => {
                        lA.push(el.id);
                        return false;
                    })
                } else {
                    data.builds.map((el) => {
                        if (el.id === obj.build.id) {
                            const tmpL = getERPcombinationsIDs(el, "lampshade");
                            lA.push(...tmpL)
                            // console.log(el, bA)
                        }

                    });
                }
            } else {
                if (obj.build.model !== "") {
                    data.builds.map((el) => {
                        bA.push(el.id);
                        if (el.id === obj.build.id) {
                            if (el.dataERP?.products.length > 0) {
                                // if ERP has products
                                lA = getERPcombinationsIDs(el, "lampshade");
                            } else { // use edge's data                                
                                lA = el.lampshades;
                            }
                        }
                        // return false;
                    })
                    /*data.lampshades.map((el) => {
                        if (el.id === obj.lampshade.id) {
                            const tmpB = getERPcombinationsIDs(el, "build");
                            bA.push(...tmpB)
                            console.log(el, bA)
                        }

                    });*/
                } else {
                    data.builds.map((el) => {
                        bA.push(el.id);
                        return false;
                    })
                    data.lampshades.map((el) => {
                        lA.push(el.id);
                        return false;
                    })
                }

            }
        }
        setFilteredID({ ...filteredID, build: bA, lampshade: lA });
        //console.log(lA);
        return;
    }

    /*useEffect(() => {
      if(model.build.id!==null){
        buildRef.current[model.build.id].scrollIntoView({ block: 'center',  behavior: 'smooth' });
        console.log("Build");
      }
      if(model.lampshade.id!==null){
        lampshadeRef.current[model.lampshade.id].scrollIntoView({ block: 'center',  behavior: 'smooth' });
        console.log("Lampshade");
      }
    },[filteredID]);*/

    function validCombinationF() {
        if (model.build.model !== "") {
            const erpIDs = getERPcombinationsIDs(model.build.data, "lampshade")
            // console.log(erpIDs, model.build)
            // if (model.build.data.lampshades.includes(model.lampshade.id) || model.lampshade.id === null) {
            if (erpIDs.includes(model.lampshade.id) || model.lampshade.id === null) {
                setValidCombination(true);
            } else {
                setValidCombination(false);
            }
            //console.log(model.build);   
        } else {
            setValidCombination(false);
        }
    }

    function closeSideOpt(type, close = false) {
        const i = iframe.contentWindow;
        const rstBtn = document.getElementById("reset");

        if (currType === type) {
            setSideOpened(null);
            setCurrType()
        } else {
            setCurrType(type)
        }
        if (close) {
            //if(type === null){
            setSideOpened(null);
            //}            
        }
        switch (sideOpened) {
            case "choose":
                prevBG.color = currentBG.color;
                prevBG.hex = currentBG.hex;
                break;
            case "palette":
                if (prevPalette.id !== currentPalette.id) {
                    rstBtn.style.display = "block"
                    prevPalette.id = currentPalette.id;
                    prevPalette.code = currentPalette.code;

                    //save palette to current color
                    colorMaterials.curr.exterior = currentPalette.code[3];
                    colorMaterials.curr.exterior2 = currentPalette.code[3];
                    colorMaterials.curr.exterior3 = currentPalette.code[3];
                    colorMaterials.curr.interior = currentPalette.code[2];
                    colorMaterials.curr.canopy = currentPalette.code[1];
                    colorMaterials.curr.stem = currentPalette.code[0];
                    //save palette to previous color
                    colorMaterials.prev.exterior = currentPalette.code[3];
                    colorMaterials.prev.exterior2 = currentPalette.code[3];
                    colorMaterials.prev.exterior3 = currentPalette.code[3];
                    colorMaterials.prev.interior = currentPalette.code[2];
                    colorMaterials.prev.canopy = currentPalette.code[1];
                    colorMaterials.prev.stem = currentPalette.code[0];
                    i.postMessage({
                        acceptMaterials: true,
                    });
                }

                break;
            // Customize all material panel
            case "individual":
                rstBtn.style.display = "block"
                currentPalette.id = null;
                currentPalette.code = null;
                prevPalette.id = currentPalette.id;
                prevPalette.code = currentPalette.code;
                i.postMessage({
                    acceptMaterials: true,
                });
                Object.keys(colorMaterials.curr).map(toggle => {
                    return colorMaterials.prev[toggle] = colorMaterials.curr[toggle];
                })
                break;
            case "options":
                prevCanopy.data = currCanopy.data;
                prevStem.data = currStem.data;
                prevVariation.data = currVariation.data;

                /*if (model.build.data.modeloptions.length > 0) {
                    i.postMessage({
                        build: prevVariation.data.code,
                    });
                }*/

                i.postMessage({
                    acceptMaterials: true,
                });
                break;
        }
    }

    // -------------------------------------------------------------------------------- Code part

    const [onMakingModel, setOnMakingModel] = useState(urlCode !== null);

    useEffect(() => {
        // console.log(setPurl);
        if (setPurl === 2) {
            var id = 0;
            const codeArray = urlCode.slice(0, urlCode.length).match(/.{1,2}/g);
            let radix = codeArray[codeArray.length - 1].includes("=") ? 36 : 16;
            const interval = setInterval(() => {
                // You'd want an exit condition here
                setModelFromCode(codeArray[id], id, false, codeArray[0], radix);
                //console.log(codeArray[id],id);
                id++;
                if (id == codeArray.length) {
                    setModelFromCode(0, 0, true, radix);
                    clearInterval(interval);
                    setOnMakingModel(false);
                }
            }, 120);

            return () => clearInterval(interval);
        }
    }, [setPurl]);

    const lampshadeRef = useRef([]);
    const buildRef = useRef([]);

    function setModelFromCode(el, i, end = false, varia = 0, radix) {
        var id = parseInt(el, radix); // convert HEX to ID      
        const ifr = iframe.contentWindow;
        const tmpVariation = parseInt(varia, radix);
        if (!end) {
            if (i === 0) {
                buildRef.current[id]?.click();
                //tmpVariation = id;
            } else if (i === 1) {
                //console.log(lampshadeRef)
                lampshadeRef.current[id]?.click();
            } else if (i === 2) {
                //console.log(currCanopy.data);
                if (id !== 0) {
                    currCanopy.data = findPartByID('canopy', id);
                    // console.log(currCanopy.data);
                    ifr.postMessage({
                        canopy: { type: currCanopy.data.code },
                    });
                }
            } else if (i === 3) {
                //console.log(currStem.data);
                if (id !== 0) {
                    currStem.data = findPartByID('stem', id);
                    console.log(currStem.data.code)
                    ifr.postMessage({
                        stem: { height: currStem.data.code },
                    });
                }
            } else if (i === 4) {
                //console.log(currStem.data);
                if (id !== 0) {
                    currVariation.data = findPartByID('variation', id, tmpVariation);
                    // console.log(currVariation.data);
                    ifr.postMessage({
                        variation: currVariation.data.code,
                    });
                }
            } else {
                const el = Object.keys(colorMaterials.default)[i - 5];
                const color = findPartByID('colors', id);
                // console.log(el + " -> " + id, color);
                if (color !== null) {
                    if (colorMaterials.default[el].code !== color.code) {
                        if (!colorMaterials.curr[el]) {
                            colorMaterials.curr[el] = {};
                        }
                        colorMaterials.curr[el].code = color.code;
                        if (!colorMaterials.prev[el]) {
                            colorMaterials.prev[el] = {};
                        }
                        colorMaterials.prev[el].code = color.code;
                        //console.log(findPartByID('colors',id),);
                        ifr.postMessage({
                            material: { type: el, color: color.code },
                        });
                    }
                } else {
                    console.log('The color for "' + el + '" component doesn\'t exist!')
                }
            }
        } else {
            ifr.postMessage({
                acceptMaterials: true,
            });
            document.getElementById("reset").style.display = "block";
        }
    }

    /* useEffect(() => {
       console.log(buildRef);
     }, [buildRef]);
     useEffect(() => {
       console.log(lampshadeRef);
     }, [lampshadeRef]);*/

    function d2h(d, version) {
        const v = version === 1 ? 36 : 16;
        var s = (+d).toString(v);
        if (s.length < 2) {
            s = '0' + s;
        }
        return s;
    }
    function setCodeFromModel() {
        /*var tmpCode = 'gghhiijjkkllmmnnooppqqrrsstt';
        const codeArray = tmpCode.match(/.{1,2}/g);*/
        const version = 1;
        const arr = code;
        dc = structuredClone(data.colors);
        //console.log(model);
        code.map((el, i) => {
            if (i === 0) {
                const b = urlMode.includes('product') ? productID.build : model.build.id;
                if (b !== null) {
                    arr[0] = d2h(b, version);
                } else {
                    arr[0] = '00';
                }
            } else if (i === 1) {
                const l = urlMode.includes('product') ? productID.lampshade : model.lampshade.id;
                if (l !== null) {
                    arr[1] = d2h(l, version);
                } else {
                    arr[1] = '00';
                }
            } else if (i === 2) {
                const c = currCanopy.data?.id;
                if (c !== undefined) {
                    arr[2] = d2h(c, version);
                } else {
                    arr[2] = '00';
                }
            } else if (i === 3) {
                const s = currStem.data?.id;
                if (s !== undefined) {
                    arr[3] = d2h(s, version);
                } else {
                    arr[3] = '00';
                }
            } else if (i === 4) {
                var s = undefined;
                model.build.data?.modeloptions.some((el, i) => {
                    // console.log(el, i)
                    if (el.code === currVariation.data.code) {
                        s = i + 1
                        return true
                    }
                    return false
                })
                if (s !== undefined) {
                    arr[4] = d2h(s, version);
                } else {
                    arr[4] = '00';
                }
            } else {
                const el = Object.keys(colorMaterials.default)[i - 5];
                if (colorMaterials.curr[el] === undefined) {
                    // console.log(colorMaterials.default, el);
                    arr[i] = d2h(mtlCodeToId(colorMaterials.default[el]?.code), version);
                } else {
                    arr[i] = d2h(mtlCodeToId(colorMaterials.curr[el].code), version);
                }
            }
        });
        arr.push("=1")
        setCode(arr);
    }

    function mtlCodeToId(mtl) {
        var mtlID = null;
        dc.some((el) => {
            if (el.code === mtl) {
                mtlID = el.id;
                return true;
            }
        })
        return mtlID;
    }

    function findPartByID(part, id, variationID = "") {
        var val = null;
        if (part === "variation") {
            data.builds.some((el) => {
                // console.log(el.id, variationID);
                if (el.id == variationID) {
                    val = el.modeloptions[id - 1];
                    //console.log(val);
                    return true
                }
                return false
            })
            //val = model.build.data.modeloptions[id-1];
        } else {
            data[part].some((el) => {
                if (el.id === id) {
                    val = el;
                    return true;
                }
                return false;
            });
        }
        return val;
    }
    function findPartByCode(part, code, zeData = null) {
        var val = null;
        const goodData = zeData || data
        // console.log(data.colors, code)
        goodData[part].some((el) => {
            if (el.code === code) {
                val = el;
                return true;
            }
            return false;
        });
        return val;
    }

    const [mobileMenu, setMobileMenu] = useState(false);
    const componentActive = mobileMenu ? 'active' : '';
    const resultActive = mobileMenu ? '' : 'active';

    const setMobileMenuF = function (state) {
        closeSideOpt("", true);
        setMobileMenu(state);
    }

    var isToggled = sideOpened === null ? "toggled" : "";
    var showTopOption = model.build.model !== "" || model.lampshade.model !== "" ? "" : "toggled";



    //OnBoarding
    var firstVisit = localStorage.getItem("firstVisit") === null ? urlCode === null ? urlMode === '' ? true : false : false : false;
    //console.log(firstVisit);

    //const [onBoarding, setOnBoarding] = useState(firstVisit);
    const [onBoardingVisible, setOnBoardingVisible] = useState(urlCode === null);
    // const [onBoardingVisible, setOnBoardingVisible] = useState(false);

    // Transition popups

    const [envVisible, setEnvVisible] = useState(false);
    const [pdfVisible, setPDFVisible] = useState(false);
    const [cartVisible, setCartVisible] = useState(false);

    const [menuEnv3D, setMenuEnv3D] = useState(true);


    // Is mobile
    const ua = navigator.userAgent.toLowerCase(), platform = navigator.platform.toLowerCase();
    const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
        isMobile = /ios|android|webos/.test(platformName);

    const [mobilePopup, setMobilePopup] = useState(false);
    //console.log(isMobile)

    const mobileRequired = (!required.build || !required.lampshade) && preSubmit ? "required" : "";

    const webLang = t('lang') === "en" ? "/fr" : "";
    //console.log("RELOADEDD");
    return (
        <LocaleContext.Provider value={{ locale, setLocale }}>
            {urlMode.includes('product') ?
                <>
                    {(loadScreen || loadMtlScreen || loadScreenInit || erpProducts.length == 0) && <LoadingScreen className="fullbg" />}
                    {Object.keys(data).length > 0 && <iframe onLoad={() => initFilters(true)} id="productIframe" title="3D product App" src={`./app/${appVersion}/index.html?guide=${urlMode?.includes('productsThumb') ? "none" : "once"}`} loading="lazy" ></iframe>}
                    {Object.keys(data).length > 0 && <PDF isProduct={true} zeUrlCode={zeUrlCode} currency={currency} zeUrlLang={zeUrlLang} setZeUrlCode={setZeUrlCode} code={code} model={model} getURL={getURL} data={data} pdfVisible={pdfVisible} setPDFVisible={setPDFVisible} dataColor={dc} setBimg={setBimg} bImg={bImg} sImg={sImg} currModel={model} mtl={mtl} />}
                </>
                :
                urlParams.get('report') === "true" ?
                    <>
                        {Object.keys(data).length > 0 && <Possibilities
                            data={data}
                        />}
                    </>
                    :
                    <>
                        {/* <button onClick={() => forceUpdateJson()}>
                            Mettre à jour le fichier JSON
                        </button> */}
                        {onMakingModel && <LoadingScreen className="full" />}
                        {isMobile && mobilePopup &&
                            <div id="mobileAlert">
                                <div>
                                    <span onClick={() => setMobilePopup(false)}>X</span>
                                    <div className="flexMobile">
                                        <div>
                                            <img src="./images/monitor.png" />
                                            <p>{t("mobileMessage")}</p>
                                        </div>
                                        <button onClick={() => setMobilePopup(false)}>{t("continueMobile")}</button>
                                    </div>
                                </div>
                            </div>
                        }
                        {err && <div id='errorPage'><div><img src="../../images/error.png" /><p>{t('errPage')}</p></div></div>}
                        {Object.keys(data).length > 0 && <Env3D
                            model={model}
                            iframe={iframe}
                            currentBGid={currentBGid}
                            setCurrentBGid={setCurrentBGid}
                            data={data}
                            envVisible={envVisible}
                            setEnvVisible={setEnvVisible} />
                        }
                        {Object.keys(data).length > 0 && <PDF
                            code={code}
                            model={model}
                            data={data}
                            pdfVisible={pdfVisible}
                            setPDFVisible={setPDFVisible}
                            dataColor={dc}
                            setBimg={setBimg}
                            bImg={bImg}
                            sImg={sImg}
                            currModel={model}
                            mtl={mtl} />
                        }
                        {Object.keys(data).length > 0 && <Cart
                            data={data}
                            currModel={model}
                            code={code}
                            cartVisible={cartVisible}
                            setCartVisible={setCartVisible}
                            cart={cart} />
                        }
                        <TopBar
                            onBoarding={onBoardingVisible}
                            setOnBoardingV={setOnBoardingVisible}
                            setCurrentBGid={setCurrentBGid}
                            currentBGid={currentBGid}
                            setEnvVisible={setEnvVisible}
                            print={printPage}
                            urlShort={urlShort}
                        />

                        {(Object.keys(data).length > 0 && iframe !== null && onBoardingVisible) && <OnBoarding
                            onBoarding={onBoardingVisible}
                            setRequired={setRequired}
                            required={required}
                            setOnBoardingV={setOnBoardingVisible}
                            setSideOpened={setSideOpened}
                            model={model}
                            lr={lampshadeRef}
                            br={buildRef}
                            data={data}
                            isMobile={isMobile}
                            getERPcombinationsIDs={getERPcombinationsIDs}
                        />
                        }
                        <div className="noprint" id="mainbody">
                            <div id="sideoptParent" className={isToggled}>
                                {Object.keys(data).length > 0 && <SideOpt
                                    modelMtls={modelMtls}
                                    forceUpdate={forceUpdate}
                                    setForceUpdate={setForceUpdate}
                                    setCurrType={setCurrType}
                                    currModel={model}
                                    data={data}
                                    modelType={mtl}
                                    iframe={iframe}
                                    opt={sideOpened}
                                    openSide={setSideOpened}
                                    erpParameters={erpParameters}
                                    dc={dc} />
                                }
                            </div>
                            {Object.keys(data).length > 0 && <SideMenu
                                preSubmit={preSubmit}
                                setRequired={setRequired}
                                isRequired={required}
                                currentBGid={currentBGid}
                                mobile={resultActive}
                                setLoadScreen={setTheLoading}
                                loadScreen={loadScreen}
                                loadScreenInit={loadScreenInit}
                                filtered={filteredID}
                                iframe={iframe}
                                data={data}
                                parentModel={set3dModel}
                                currModel={model}
                                lampshadeRef={lampshadeRef}
                                buildRef={buildRef}
                                resetAll={resetAll}
                                isResetAll={isResetAll}
                                setIsResetAll={setIsResetAll}
                                erpProducts={erpProducts}
                            />
                            }
                            <div id="rightBody">
                                {(loadScreen || loadMtlScreen || loadScreenInit || erpProducts.length === 0) && <LoadingScreen className="fullbg" />}
                                {!validCombination && <div id="invalidSelection"><p>{t("pleaseSelect")}</p></div>}
                                <a data-lang={t("lang-logo")} target="blank" id="poweredByED" href={"https://www.edgedimension.com" + webLang}></a>
                                {Object.keys(data).length > 0 && <div id="appIframeParent"><iframe onLoad={() => initFilters()} id="appIframe" title="3D App" src={"./app/" + appVersion + "/index.html?guide=always"} loading="lazy" ></iframe></div>}
                                {Object.keys(data).length > 0 && <OptionTop
                                    currentBGid={currentBGid}
                                    forceUpdate={forceUpdate}
                                    setForceUpdate={setForceUpdate}
                                    preSubmit={preSubmit}
                                    setRequired={setRequired}
                                    isRequired={required}
                                    iframe={iframe}
                                    canShow={showTopOption}
                                    parentModel={set3dModel}
                                    currModel={model}
                                    opt={sideOpened}
                                    openSide={setSideOpened}
                                    closeSideOpt={closeSideOpt}
                                    restBtnRef={restBtnRef} />
                                }
                                {Object.keys(data).length > 0 && <BottomBar
                                    setPreSubmit={setPreSubmit}
                                    isRequired={required}
                                    makeCode={setCodeFromModel}
                                    setCartVisible={setCartVisible}
                                    mtl={mtl}
                                    cart={cart}
                                    setCart={setCart}
                                    filtered={filteredID}
                                    data={data}
                                    currModel={model}
                                    erpLink={urlApi}
                                    currParameters={currParameters}
                                    setCurrParameters={setCurrParameters}
                                    erpProducts={erpProducts}
                                    forceUpdate={forceUpdate}
                                    currency={currency}
                                    iframe={iframe}
                                    thumb={thumb}
                                    setThumb={setThumb}
                                    print={printPage}
                                />
                                }
                                {Object.keys(data).length > 0 && <RightOpt
                                    model={model}
                                    data={data}
                                    iframe={iframe}
                                    setCurrentBGid={setCurrentBGid}
                                    currentBGid={currentBGid}
                                    setEnvVisible={setEnvVisible}
                                    id='rightOptions'
                                    menuEnv3D={menuEnv3D}
                                    setMenuEnv3D={setMenuEnv3D}
                                />
                                }
                                {currentBGid !== null &&
                                    <div id='envMeasures'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>{t("ceilingH") + " : "}</td>
                                                    <td>{bgValues[currentBGid - 1].ceilingH + '\''}</td>
                                                </tr>
                                                {bgValues[currentBGid - 1].type !== "heightOnly" && <tr>
                                                    <td>{(bgValues[currentBGid - 1].type === "island" ? t("islandW") : t("tableW")) + " : "}</td>
                                                    <td>{bgValues[currentBGid - 1].islandW + '\''}</td>
                                                </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                            <div id="bottomMobile">
                                <div onClick={() => setMobileMenuF(true)} className={"bottomButton " + componentActive + " " + mobileRequired}><span></span><p>{t('components')}</p></div>
                                <div onClick={() => setMobileMenuF(false)} className={"bottomButton " + resultActive}><span></span><p>{t('result')}</p></div>
                            </div>
                        </div>
                    </>
            }
        </LocaleContext.Provider>
    );
}

export default App;
